/**
 * The group a station is written into.
 *
 * Station groups belong to Manual Operations (`/api/station/stationgroup`) —
 * that is where one is made and where stations are attached to it, and nothing
 * in the station forms or the station grid manages them. Written blind: the
 * station read endpoints do not return `stationGroupId`, so a save cannot
 * round-trip the group a station is already in.
 *
 * Not 0: POST `/api/station` refuses a zero with `2102 data constraint
 * violation` — a foreign key matching no group. PUT accepts it, but since the
 * reads never show the column back there is no way to tell what a zero writes,
 * so every path sends the same real group.
 */
export const STATION_GROUP_ID = 1
